module.exports = __webpack_public_path__ + "img/1791980074990.40d67b71.png";